'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var hexToRgb = require('./hexToRgb-7c8edffc.js');

var buttonVariantsStyles = {
    // Deprecated variants
    primary: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    color: ", ";\n    background-color: ", ";\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n      opacity: 0.9;\n    }\n  "], ["\n    border-color: ", ";\n    color: ", ";\n    background-color: ", ";\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n      opacity: 0.9;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    secondary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    color: ", ";\n    background-color: ", ";\n    &:hover:not([disabled]) {\n      background-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    color: ", ";\n    background-color: ", ";\n    &:hover:not([disabled]) {\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primaryHoverGhost;
    }),
    primaryLink: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    border: none;\n    color: ", ";\n    &:hover:not([disabled]) {\n      background-color: ", ";\n      font-weight: 500;\n    }\n  "], ["\n    background-color: ", ";\n    border: none;\n    color: ", ";\n    &:hover:not([disabled]) {\n      background-color: ", ";\n      font-weight: 500;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
    link: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    color: ", ";\n    background-color: ", ";\n  "], ["\n    border-color: ", ";\n    color: ", ";\n    background-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
    primaryHeader: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n    text-transform: uppercase;\n    font-weight: normal;\n    font-size:  ", ";\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n    text-transform: uppercase;\n    font-weight: normal;\n    font-size:  ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.fontSizes.md;
    }),
    closeButton: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background: ", ";\n    border: none;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.3s ease;\n    align-self: flex-start;\n\n    & {\n      padding: 0;\n    }\n\n    & svg {\n      fill: currentColor;\n      height: 14px;\n      width: 14px;\n    }\n\n    &:hover, &:focus {\n      opacity: 1;\n    }\n  "], ["\n    color: ", ";\n    background: ", ";\n    border: none;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.3s ease;\n    align-self: flex-start;\n\n    & {\n      padding: 0;\n    }\n\n    & svg {\n      fill: currentColor;\n      height: 14px;\n      width: 14px;\n    }\n\n    &:hover, &:focus {\n      opacity: 1;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }),
    cancelButton: styled.css(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    transition: color 0.3s ease;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n    transition: color 0.3s ease;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }),
    danger: styled.css(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "], ["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.pink;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }),
    disabled: styled.css(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n    background-color: rgba(", ", .1);\n    color: ", ";\n    border: none;\n  "], ["\n    background-color: rgba(", ", .1);\n    color: ", ";\n    border: none;\n  "])), function (_a) {
        var _b;
        var theme = _a.theme;
        return (_b = hexToRgb.hexToRgb(theme.colors.primary)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    }),
    cta: styled.css(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    border: none;\n    padding: 6px 16px;\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    border: none;\n    padding: 6px 16px;\n    &:hover {\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.blue;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.admin.blueAlt;
    }),
    skip: styled.css(templateObject_11 || (templateObject_11 = tslib_es6.__makeTemplateObject(["\n    background: ", ";\n    border: none;\n    color: ", ";\n\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n  "], ["\n    background: ", ";\n    border: none;\n    color: ", ";\n\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyLight;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
    floorPlan: styled.css(templateObject_12 || (templateObject_12 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 125px;\n    border: none;\n    height: 40px;\n    width: 152px;\n  "], ["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 125px;\n    border: none;\n    height: 40px;\n    width: 152px;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.floorPlan.blue;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }),
    // Actual variants
    Primary: styled.css(templateObject_13 || (templateObject_13 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out, border-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out, border-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.primary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.primaryHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.primaryHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.primaryActive;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.primaryActive;
    }),
    Secondary: styled.css(templateObject_14 || (templateObject_14 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out, border-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n"], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out, border-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n"])), function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.secondary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.secondary;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.secondaryHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.secondaryHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.secondaryActive;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.secondaryActive;
    }),
    Destructive: styled.css(templateObject_15 || (templateObject_15 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out, border-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out, border-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.destructive;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.destructive;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.destructiveHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.destructiveHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.destructiveActive;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.destructiveActive;
    }),
    Outline: styled.css(templateObject_16 || (templateObject_16 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      background-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-weight: 500;\n    transition: background-color .5s ease-out;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.white;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.outlineHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.outlineActive;
    }),
    Plain: styled.css(templateObject_17 || (templateObject_17 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    transition: background-color .5s ease-out;\n    font-weight: normal;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      background-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    transition: background-color .5s ease-out;\n    font-weight: normal;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.outlineHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.outlineActive;
    }),
    Skip: styled.css(templateObject_18 || (templateObject_18 = tslib_es6.__makeTemplateObject(["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    transition: background-color .5s ease-out;\n    font-weight: normal;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      background-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    transition: background-color .5s ease-out;\n    font-weight: normal;\n    &:hover:not([disabled]), &:focus:not([disabled]) {\n      background-color: ", ";\n    }\n    &:active:not([disabled]) {\n      background-color: ", ";\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.universal.transparent;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyLight;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.hqo.skipHover;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyMedium;
    }),
};
var buttonSizeStyles = {
    // Deprecated sizes
    xxs: styled.css(templateObject_19 || (templateObject_19 = tslib_es6.__makeTemplateObject(["\n    padding: 4px 16px;\n    font-weight: normal;\n  "], ["\n    padding: 4px 16px;\n    font-weight: normal;\n  "]))),
    xs: styled.css(templateObject_20 || (templateObject_20 = tslib_es6.__makeTemplateObject(["\n    padding: 4px 24px;\n    font-weight: normal;\n  "], ["\n    padding: 4px 24px;\n    font-weight: normal;\n  "]))),
    sm: styled.css(templateObject_21 || (templateObject_21 = tslib_es6.__makeTemplateObject(["\n    padding: 3px 34px;\n    font-weight: normal;\n  "], ["\n    padding: 3px 34px;\n    font-weight: normal;\n  "]))),
    's/m': styled.css(templateObject_22 || (templateObject_22 = tslib_es6.__makeTemplateObject(["\n    padding: 4px 32px;\n    font-size:  ", ";\n    line-height: 22px;\n  "], ["\n    padding: 4px 32px;\n    font-size:  ", ";\n    line-height: 22px;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.fontSizes.sm;
    }),
    md: styled.css(templateObject_23 || (templateObject_23 = tslib_es6.__makeTemplateObject(["\n    padding: 3px 42px;\n    font-weight: normal;\n  "], ["\n    padding: 3px 42px;\n    font-weight: normal;\n  "]))),
    lg: styled.css(templateObject_24 || (templateObject_24 = tslib_es6.__makeTemplateObject(["\n    padding: 7px 48px;\n    text-transform: uppercase;\n    font-weight: 500;\n  "], ["\n    padding: 7px 48px;\n    text-transform: uppercase;\n    font-weight: 500;\n  "]))),
    tenant: styled.css(templateObject_25 || (templateObject_25 = tslib_es6.__makeTemplateObject(["\n    min-width: 345px;\n    font-size: 16px;\n    line-height: 19px;\n    height: 50px;\n  "], ["\n    min-width: 345px;\n    font-size: 16px;\n    line-height: 19px;\n    height: 50px;\n  "]))),
    cta: styled.css(templateObject_26 || (templateObject_26 = tslib_es6.__makeTemplateObject(["\n    font-family: ", ";\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n  "], ["\n    font-family: ", ";\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.fonts.join();
    }),
    floorPlan: styled.css(templateObject_27 || (templateObject_27 = tslib_es6.__makeTemplateObject(["\n    padding: 10px 24px 8px 24px;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    font-style: normal;\n  "], ["\n    padding: 10px 24px 8px 24px;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px;\n    font-style: normal;\n  "]))),
    // Actual sizes
    m: styled.css(templateObject_28 || (templateObject_28 = tslib_es6.__makeTemplateObject(["\n    padding: 4px 15px;\n  "], ["\n    padding: 4px 15px;\n  "]))),
    l: styled.css(templateObject_29 || (templateObject_29 = tslib_es6.__makeTemplateObject(["\n    padding: 12px 23px;\n  "], ["\n    padding: 12px 23px;\n  "]))),
    xl: styled.css(templateObject_30 || (templateObject_30 = tslib_es6.__makeTemplateObject(["\n    padding: 12px 23px;\n    width: 360px;\n  "], ["\n    padding: 12px 23px;\n    width: 360px;\n  "]))),
    // Icon button sizes
    icon: styled.css(templateObject_31 || (templateObject_31 = tslib_es6.__makeTemplateObject(["\n    padding: 3px;\n  "], ["\n    padding: 3px;\n  "]))),
};
var buttonDisabledStyles = {
    primary: styled.css(templateObject_32 || (templateObject_32 = tslib_es6.__makeTemplateObject(["\n    opacity: 0.5;\n  "], ["\n    opacity: 0.5;\n  "]))),
    miniApp: styled.css(templateObject_33 || (templateObject_33 = tslib_es6.__makeTemplateObject(["\n    background-color: ", ";\n    border-color: ", ";\n  "], ["\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedDarkGrey;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.sharedDarkGrey;
    }),
};
var StyledButton = styled__default.button(templateObject_34 || (templateObject_34 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n\n  height: inherit;\n  cursor: pointer;\n  border-radius: 4px;\n  border-width: 1px;\n  border-style: solid;\n\n  margin: 0;\n  text-align: center;\n  font-family: ", ";\n  font-style: normal;\n  font-size: 14px;\n  line-height: 22px;\n\n  ", "\n  ", "\n  ", "\n  &:disabled {\n    ", "\n    cursor: not-allowed;\n  }\n  & span {\n    line-height: inherit;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n\n  height: inherit;\n  cursor: pointer;\n  border-radius: 4px;\n  border-width: 1px;\n  border-style: solid;\n\n  margin: 0;\n  text-align: center;\n  font-family: ", ";\n  font-style: normal;\n  font-size: 14px;\n  line-height: 22px;\n\n  ", "\n  ", "\n  ",
    "\n  &:disabled {\n    ", "\n    cursor: not-allowed;\n  }\n  & span {\n    line-height: inherit;\n  }\n"])), function (_a) {
    var showIcon = _a.showIcon;
    return (showIcon ? 'space-between' : 'center');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var variant = _a.variant;
    return buttonVariantsStyles[variant];
}, function (_a) {
    var size = _a.size, showIcon = _a.showIcon, showText = _a.showText;
    return buttonSizeStyles[showIcon && !showText ? 'icon' : size];
}, function (_a) {
    var isSkeleton = _a.isSkeleton, theme = _a.theme;
    return isSkeleton && "\n    pointer-events: none;\n    border-color: " + theme.colors.greys.adminGreyMedium + ";\n    background-color: " + theme.colors.greys.adminGreyMedium + ";\n\n    &:hover:not([disabled]), &:focus:not([disabled]), &:active:not([disabled]), &:disabled {\n      border-color: " + theme.colors.greys.adminGreyMedium + ";\n      background-color: " + theme.colors.greys.adminGreyMedium + ";\n    }\n\n    & > span, & > div { visibility: hidden; }\n  ";
}, function (_a) {
    var disabledStyle = _a.disabledStyle;
    return buttonDisabledStyles[disabledStyle];
});
var ButtonContent = styled__default.span(templateObject_35 || (templateObject_35 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  visibility: ", ";\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  visibility: ", ";\n  display: flex;\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var loading = _a.loading;
    return (loading ? 'hidden' : 'visible');
}, function (_a) {
    var iconDirection = _a.iconDirection;
    return (iconDirection === 'right' ? 'row' : 'row-reverse');
});
var Text = styled__default.span(templateObject_36 || (templateObject_36 = tslib_es6.__makeTemplateObject(["\n  ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"], ["\n  ",
    ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (_a) {
    var multiline = _a.multiline;
    return !multiline
        && "display: block;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n  }";
}, function (_a) {
    var showIcon = _a.showIcon, iconDirection = _a.iconDirection;
    return (showIcon && iconDirection === 'left' && '4px');
}, function (_a) {
    var showIcon = _a.showIcon, iconDirection = _a.iconDirection;
    return (showIcon && iconDirection === 'right' && '4px');
});
var LoaderContainer = styled__default.div(templateObject_37 || (templateObject_37 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37;

exports.ButtonContent = ButtonContent;
exports.LoaderContainer = LoaderContainer;
exports.StyledButton = StyledButton;
exports.Text = Text;
exports.buttonSizeStyles = buttonSizeStyles;
exports.buttonVariantsStyles = buttonVariantsStyles;
